import { render, staticRenderFns } from "./ServiceRecordDetail.vue?vue&type=template&id=16b33758&scoped=true"
import script from "./ServiceRecordDetail.vue?vue&type=script&lang=js"
export * from "./ServiceRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecordDetail.vue?vue&type=style&index=0&id=16b33758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b33758",
  null
  
)

export default component.exports